import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../utils";
import useInput from "../../hooks/useInput";
import "./login.css";
import {
  loginUser,
  verifyOtp,
  resetLoginSuccess,
  setUserAndToken,
} from "../../redux/auth/authSlice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { IoCheckmarkCircle, IoClose } from "react-icons/io5";
import CreateBusiness from "../business/createbusiness";
import {
  fetchBusiness,
  setActiveBusiness,
} from "../../redux/business/businessSlice";
import { updateUser, verifyPin } from "../../services/services";
import axios from "axios";
const countryCodes = [
  {
    code: "+91",
    name: "",
    image: "/assets/img/ind.png",
  },
  {
    code: "+1",
    name: "",
    image: "/assets/img/Us.png",
  },
];

const Login = () => {
  const [countryCode, setCountryCode] = useState("+91");

  const mobile = useInput("");
  const [errors, setErrors] = useState({});
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showCreateBusiness, setShowCreateBusiness] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [screen, setScreen] = useState("phone");

  const [pin, setPin] = useState(["", "", "", ""]);
  const [forgotPinFlow, setForgotPinFlow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    loading,
    error,
    otpSent,
    hasPin,
    hasBusiness,
    loginSuccess,
    redirectTo,
  } = useSelector((state) => state.auth);

  useEffect(() => {
    // if (forgotPinFlow && loginSuccess) {
    //   setScreen("createPin");
    //   setForgotPinFlow(false);
    //   return;
    // }

    if (redirectTo === "createPin") {
      setScreen("createPin");
    } else if (redirectTo === "pin") {
      setScreen("pin");
    } else if (redirectTo === "business") {
      setShowCreateBusiness(true);
    } else if (otpSent) {
      setScreen("otp");
    }
  }, [redirectTo, otpSent, forgotPinFlow, loginSuccess]);

  useEffect(() => {
    if (screen === "createPin") {
      setPin(["", "", "", ""]);
    }
  }, [screen]);

  const { user, token } = useSelector((state) => state.auth);

  const handlePinChange = (index, value) => {
    // if (!/^[0-9]?$/.test(value)) return;
    if (!/^\d?$/.test(value)) return;
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    if (value && index < 3) {
      const nextInput = document.getElementById(`pin-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };
  const handlePinKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      const newPin = [...pin];

      // if current box already empty → go to previous
      if (!newPin[index] && index > 0) {
        const prevInput = document.getElementById(`pin-${index - 1}`);
        if (prevInput) prevInput.focus();

        newPin[index - 1] = "";
        setPin(newPin);
      } else {
        // remove current value
        newPin[index] = "";
        setPin(newPin);
      }
    }
  };
  const handleCreatePin = async (e) => {
    e.preventDefault();
    const pinValue = pin.join("");
    if (pinValue.length !== 4) {
      toastError("Enter valid PIN");
      return;
    }

    try {
      if (!user?._id) {
        toastError("User not found. Please login again.");
        return;
      }

      const res = await updateUser(user._id, { pin: pinValue });
      const responseData = res?.data?.response;

      const updatedUser = responseData?.user;
      const newToken = responseData?.token;

      if (!newToken) {
        toastError("No token received from server");
        return;
      }

      localStorage.setItem("User_Token", newToken);
      localStorage.setItem("Login_User", JSON.stringify(updatedUser));

      axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      dispatch(setUserAndToken({ user: updatedUser, token: newToken }));

      await new Promise((resolve) => setTimeout(resolve, 100));

      let businesses = [];
      try {
        const fetchResult = await dispatch(fetchBusiness(updatedUser._id));
        if (fetchResult.meta.requestStatus === "fulfilled") {
          businesses = Array.isArray(fetchResult.payload)
            ? fetchResult.payload
            : [];
        }
      } catch (fetchErr) {
        console.warn("Fetch after PIN failed:", fetchErr);
      }

      const activeBiz =
        businesses.find((b) => b._id === updatedUser.activeBusiness) ||
        businesses[0];

      if (activeBiz) {
        dispatch(setActiveBusiness(activeBiz));
        localStorage.setItem("selectedBusiness", JSON.stringify(activeBiz));
      }

      toastSuccess("PIN created successfully");
      navigate("/dashboard");
    } catch (err) {
      console.error("PIN ERROR:", err);
      toastError(err?.response?.data?.message || "Failed to create PIN");
    }
  };

  const handlePinSubmit = async (e) => {
    e.preventDefault();

    const pinValue = pin.join("").trim();
    const phone = localStorage.getItem("login_phone");

    if (pinValue.length !== 4) {
      toastError("Enter valid 4 digit PIN");
      return;
    }

    try {
      const res = await verifyPin({ phone, pin: pinValue });

      const { token, user } = res.data.response;
      localStorage.removeItem("selectedBusiness");

      // Update redux + axios header
      dispatch(setUserAndToken({ user, token }));

      // Save to localStorage
      localStorage.setItem("User_Token", token);
      localStorage.setItem("Login_User", JSON.stringify(user));

      const businesses = await dispatch(fetchBusiness(user._id)).unwrap();

      if (user.activeBusiness) {
        const activeBiz = businesses.find((b) => b._id === user.activeBusiness);
        if (activeBiz) {
          dispatch(setActiveBusiness(activeBiz));
        }
      }

      localStorage.setItem("Login_User", JSON.stringify(user));

      toastSuccess("Login successful");
      navigate("/dashboard");
    } catch (error) {
      toastError(error.response?.data?.message || "Invalid PIN");
    }
  };

  const handleForgotPin = () => {
    setForgotPinFlow(true);

    setOtp(["", "", "", ""]);
    setPin(["", "", "", ""]);

    dispatch(
      loginUser({
        phone: mobile.value,
        country_code: countryCode,
        forceOtp: true,
      }),
    );

    setScreen("otp");
  };

  const validateMobile = () => {
    const newErrors = {};
    if (!mobile.value.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(mobile.value)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateMobile()) return;
    //  setOtp(["", "", "", ""]);
    dispatch(
      loginUser({
        phone: mobile.value,
        country_code: countryCode,
      }),
    );
    localStorage.setItem("login_phone", mobile.value);
    // setResendTimer(60);
  };

  const handleOtpChange = (index, value) => {
    if (!value) {
      // Backspace clear logic
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        document.getElementById(`otp-${index - 1}`)?.focus();
      }
      return;
    }

    // If pasted full OTP (only handle in first input)
    if (index === 0 && value.length > 1) {
      const digits = value.replace(/\D/g, "").slice(0, 4).split("");
      const newOtp = ["", "", "", ""];
      digits.forEach((d, i) => (newOtp[i] = d));
      setOtp(newOtp);

      // Focus last filled box
      const lastIndex = digits.length - 1;
      document.getElementById(`otp-${lastIndex}`)?.focus();
      return;
    }

    // Normal single digit input
    if (!/^[0-9]$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto move forward
    if (index < 3) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
    if (newOtp.join("").length === 4) {
      setTimeout(() => {
        document.getElementById("otp-submit")?.click();
      }, 800);
    }
  };
  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const newOtp = [...otp];
      newOtp[index - 1] = "";
      setOtp(newOtp);
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("").trim();

    if (otpValue.length !== 4) {
      toastError("Please enter a valid 4-digit OTP");
      return;
    }

    dispatch(
      verifyOtp({
        phone: mobile.value,
        otp: otpValue,
        resetPinFlow: forgotPinFlow,
      }),
    );
  };

  const handleChangeNumber = () => {
    setOtp(["", "", "", ""]);
    // mobile.onChange({ target: { value: "" } });
    setScreen("phone");
  };
  const handleResendOtp = (e) => {
    e.preventDefault();

    setOtp(["", "", "", ""]);

    setTimeout(() => {
      document.getElementById("otp-0")?.focus();
    }, 200);

    dispatch(
      loginUser({
        phone: mobile.value,
        country_code: countryCode,
        forceOtp: true,
      }),
    );
    setResendTimer(60);
  };

  useEffect(() => {
    if (otpSent) {
      toastSuccess(`OTP sent to ${countryCode} ${mobile.value}`);

      // window.history.pushState({ screen: "otp" }, "");

      setScreen("otp");
      setResendTimer(60);

      setTimeout(() => {
        document.getElementById("otp-0")?.focus();
      }, 300);
    }
  }, [otpSent]);

  useEffect(() => {
    if (error) {
      const msg = typeof error === "string" ? error : error.message;
      toastError(msg || "Something went wrong");
    }
  }, [error]);

  useEffect(() => {
    setOtp(["", "", "", ""]);
    mobile.onChange({ target: { value: "" } });
  }, []);

  // useEffect(() => {
  //   const handlePopState = () => {
  //     setScreen("phone");
  //     setOtp(["", "", "", ""]);
  //     setPin(["", "", "", ""]);
  //   };

  //   window.addEventListener("popstate", handlePopState);

  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, []);

  const resetToPhoneScreen = () => {
    setShowCreateBusiness(false);
    setOtp(["", "", "", ""]);
    mobile.onChange({ target: { value: "" } });
    setScreen("phone");
  };

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleBusinessCreated = async (created) => {
    try {
      const { business, user: updatedUser } = created || {};

      const newToken = localStorage.getItem("User_Token");

      if (updatedUser) {
        localStorage.setItem("Login_User", JSON.stringify(updatedUser));
        dispatch(setUserAndToken({ user: updatedUser, token: newToken }));
        axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      }

      let businesses = [];
      try {
        const fetchResult = await dispatch(
          fetchBusiness(updatedUser?._id || user?._id),
        );
        if (fetchResult.meta.requestStatus === "fulfilled") {
          businesses = Array.isArray(fetchResult.payload)
            ? fetchResult.payload
            : [];
        } else {
          console.warn("fetchBusiness rejected:", fetchResult.payload);
        }
      } catch (fetchErr) {
        console.warn("Fetch business error (using fallback):", fetchErr);
      }

      if (businesses.length === 0 && business) {
        businesses = [business];
      }

      // 4. Set active business
      const activeBizId = updatedUser?.activeBusiness || business?._id;
      let activeBiz = businesses.find((b) => b._id === activeBizId);

      if (!activeBiz && businesses.length > 0) {
        activeBiz = businesses[0];
      }

      if (activeBiz) {
        dispatch(setActiveBusiness(activeBiz));
        localStorage.setItem("selectedBusiness", JSON.stringify(activeBiz));
      } else {
        console.warn("Could not set active business");
      }

      toastSuccess("Business created successfully!");
      // Force Redux to load the latest list
      dispatch(fetchBusiness(updatedUser._id || user?._id));
      // ALWAYS move to Create PIN screen (no early return)
      setShowCreateBusiness(false);
      setScreen("createPin");
    } catch (err) {
      console.error("handleBusinessCreated error:", err);
      toastError("Business created, proceeding to PIN screen...");

      // Still move forward even on any error
      setShowCreateBusiness(false);
      setScreen("createPin");
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg, #f6f9ff 0%, #f0f4ff 100%)",
        height: "100vh",
      }}
    >
      <div className="container">
        <div className="row g-0 align-items-center">
          {/* LEFT SIDE*/}
          <div className="col-md-7 d-none d-md-block ">
            <div>
              <div>
                <img
                  src="/assets/img/ab_book_logo.png"
                  alt="Assist Buddi Book Logo"
                  style={{
                    height: "3.5rem",
                    width: "12rem",
                    objectFit: "contain",
                  }}
                />
                <p
                  className="fw-semibold pt-4 fs-3"
                  style={{ maxWidth: "500px", color: "#808080" }}
                >
                  Simplify your{" "}
                  <span style={{ color: "#0c1e7e" }}>
                    business and finance management
                  </span>{" "}
                  with smart automation tools.
                </p>
                {/* style={{
                          background:
                            "linear-gradient(45deg, rgb(12, 30, 126), rgb(2, 226, 208))",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }} */}

                <div className="text-black small pt-3 d-flex flex-wrap gap-4">
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "#0b2b6d" }}
                  >
                    <IoCheckmarkCircle size={16} />
                    <span className=" fs-7 ms-2 fw-semibold">AI Powered</span>
                  </div>
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "#0b2b6d" }}
                  >
                    <IoCheckmarkCircle size={16} />
                    <span className=" fs-7 ms-2 fw-semibold">
                      Smart Automated
                    </span>
                  </div>
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "#0b2b6d" }}
                  >
                    <IoCheckmarkCircle size={16} />
                    <span className=" fs-7 ms-2 fw-semibold">Future Ready</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE – Form Area */}
          {showCreateBusiness ? (
            <div className="col-md-5">
              <CreateBusiness
                onBackToLogin={resetToPhoneScreen}
                onBusinessCreated={handleBusinessCreated}
              />
            </div>
          ) : (
            <div className="col-md-5">
              <div className="card shadow-md border-0">
                <div className="p-4 p-md-5">
                  {/* Small logo + welcome text */}
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="text-start">
                      <img
                        src="/assets/img/ab_book_logo_icon.png"
                        alt="Logo Icon"
                        style={{ height: "50px", width: "55px" }}
                      />
                      <p className="text-muted mt-2">
                        Welcome to{" "}
                        <span
                          className="fw-bold"
                          style={{
                            background:
                              "linear-gradient(45deg, rgb(12, 30, 126), rgb(2, 226, 208))",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                          }}
                        >
                          Assist Buddi Books
                        </span>
                      </p>
                    </div>

                    {screen !== "phone" && (
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          type="button"
                          className="btn btn-sm border-0 shadow-none p-0"
                          onClick={() => {
                            dispatch(resetLoginSuccess());

                            setScreen("phone");

                            setOtp(["", "", "", ""]);
                            setPin(["", "", "", ""]);

                            setForgotPinFlow(false);
                          }}
                        >
                          <IoClose size={20} />
                        </button>
                      </div>
                    )}
                  </div>

                  {/* ─── LOGIN FORM ─── */}
                  {screen === "phone" && (
                    <div>
                      <h5 className="mb-4 fw-bold fs-2 text-dark">
                        Get started with your phone number
                      </h5>

                      <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                          {/* <PhoneInput
                            country="in"
                            value={phone}
                            // onlyCountries={["in", "us", "gb", "ae", "sg"]}
                            onChange={handlePhoneChange}
                            inputProps={{
                              name: "mobile",
                              required: true,
                              autoFocus: true,
                              placeholder: "Enter mobile number...",
                            }}
                            containerStyle={{
                              display: "flex",
                              width: "100%",
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                            }}
                            buttonStyle={{
                              // background: "#f3f4f6",
                              border: "none",
                              borderRight: "1px solid #d1d5db",
                              padding: "0 8px",
                            }}
                            inputStyle={{
                              width: "100%",
                              height: "48px",
                              border: "none",
                              borderRadius: "0",
                              fontSize: "16px",
                              background: "white",
                              paddingLeft: "60px",
                            }}
                          />
                          {errors.mobile && (
                            <div className="text-danger small mt-1">
                              {errors.mobile}
                            </div>
                          )} */}
                          <div className="phone-wrapper d-flex">
                            <div className="country-select-custom">
                              <img
                                src={
                                  countryCodes.find(
                                    (c) => c.code === countryCode,
                                  )?.image
                                }
                                alt="flag"
                                className="flag-img"
                              />

                              <select
                                value={countryCode}
                                onChange={(e) => setCountryCode(e.target.value)}
                                className="form-select-sm country-select "
                              >
                                {countryCodes.map((cc) => (
                                  <option key={cc.code} value={cc.code}>
                                    {cc.name.toUpperCase()} {cc.code}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <input
                              type="tel"
                              placeholder="Enter phone"
                              className="phone-input w-100"
                              value={mobile.value}
                              // onChange={(e) => {
                              //   const value = e.target.value
                              //     .replace(/\D/g, "")
                              //     .slice(0, 10);
                              //   mobile.onChange({ target: { value } });

                              //   if (value.length < 10) {
                              //     setErrors({
                              //       mobile: "Mobile number must be 10 digits",
                              //     });
                              //   } else {
                              //     setErrors({});
                              //   }
                              // }}
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, "");

                                // prevent starting with 0-5
                                if (
                                  value.length === 1 &&
                                  !/[6-9]/.test(value)
                                ) {
                                  return;
                                }

                                value = value.slice(0, 10);

                                mobile.onChange({ target: { value } });

                                if (!/^[6-9]\d{0,9}$/.test(value)) {
                                  setErrors({
                                    mobile: "Enter valid mobile number",
                                  });
                                } else if (value.length < 10) {
                                  setErrors({
                                    mobile: "Mobile number must be 10 digits",
                                  });
                                } else {
                                  setErrors({});
                                }
                              }}
                            />
                          </div>{" "}
                          {errors.mobile && (
                            <div className="text-danger small mt-1">
                              {errors.mobile}
                            </div>
                          )}
                        </div>

                        <button
                          type="submit"
                          className="btn bg-custom text-white w-100 py-2"
                          disabled={loading}
                        >
                          {loading ? "Please wait..." : "Login"}
                        </button>
                      </form>

                      <div className=" small text-muted mt-4">
                        By continuing, you agree to our{" "}
                        <Link
                          to="https://www.assistbuddi.com/privacy-policy"
                          className="text-primary"
                        >
                          privacy policy
                        </Link>{" "}
                        and{" "}
                        <Link
                          to="https://www.assistbuddi.com/terms-and-conditions"
                          className="text-primary"
                        >
                          terms of use
                        </Link>
                        .
                      </div>
                    </div>
                  )}

                  {/* ─── OTP FORM ─── */}
                  {screen === "otp" && (
                    <div>
                      <h5 className="mb-4 fw-bold fs-2 text-dark">
                        Enter the OTP sent to your phone
                      </h5>

                      <div className="text-muted small mb-4">
                        {countryCode} {mobile.value}{" "}
                        <button
                          type="button"
                          onClick={handleChangeNumber}
                          className="btn btn-link p-0 text-primary"
                        >
                          Change
                        </button>
                      </div>
                      <form onSubmit={handleOtpSubmit}>
                        <div className="d-flex justify-content-between mb-4 gap-2">
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              id={`otp-${index}`}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              pattern="[0-9]*"
                              className="form-control text-center"
                              style={{
                                height: "55px",
                                fontSize: "1.6rem",
                                borderRadius: "10px",
                              }}
                              value={digit}
                              onChange={(e) =>
                                handleOtpChange(index, e.target.value)
                              }
                              onKeyDown={(e) => handleOtpKeyDown(index, e)}
                            />
                          ))}
                        </div>

                        <div className="text-end mb-4">
                          <Link
                            to="#"
                            onClick={resendTimer === 0 ? handleResendOtp : null}
                            className={`text-decoration-none small ${
                              resendTimer > 0 ? "text-muted" : "text-primary"
                            }`}
                          >
                            {resendTimer > 0
                              ? `Resend in ${resendTimer}s`
                              : "Resend OTP"}
                          </Link>
                        </div>

                        <button
                          type="submit"
                          id="otp-submit"
                          className="btn bg-custom text-white w-100 py-2"
                          disabled={loading}
                        >
                          {loading ? "Verifying..." : "Verify OTP"}
                        </button>
                      </form>
                    </div>
                  )}

                  {screen === "createPin" && (
                    <div>
                      <h5 className="mb-4 fw-bold fs-2 text-dark">
                        Create your PIN
                      </h5>

                      <form onSubmit={handleCreatePin}>
                        <div className="d-flex gap-2 mb-4">
                          {pin.map((digit, index) => (
                            <input
                              key={index}
                              id={`pin-${index}`}
                              type="password"
                              maxLength={1}
                              className="form-control text-center"
                              value={digit}
                              onChange={(e) =>
                                handlePinChange(index, e.target.value)
                              }
                              onKeyDown={(e) => handlePinKeyDown(index, e)}
                              style={{
                                height: "55px",
                                fontSize: "1.6rem",
                                borderRadius: "10px",
                              }}
                            />
                          ))}
                        </div>

                        <button className="btn bg-custom text-white w-100">
                          Create PIN
                        </button>
                      </form>
                    </div>
                  )}
                  {/* ─── PIN FORM ─── */}
                  {screen === "pin" && (
                    <div>
                      <h5 className="mb-4 fw-bold fs-2 text-dark">
                        Enter your PIN
                      </h5>

                      <form onSubmit={handlePinSubmit}>
                        <div className="d-flex justify-content-between mb-4 gap-2">
                          {pin.map((digit, index) => (
                            <input
                              key={index}
                              id={`pin-${index}`}
                              type="password"
                              maxLength={1}
                              className="form-control text-center"
                              style={{
                                height: "55px",
                                fontSize: "1.6rem",
                                borderRadius: "10px",
                              }}
                              value={digit}
                              onChange={(e) =>
                                handlePinChange(index, e.target.value)
                              }
                              onKeyDown={(e) => handlePinKeyDown(index, e)}
                            />
                          ))}
                        </div>

                        <button
                          type="submit"
                          className="btn bg-custom text-white w-100 py-2"
                        >
                          Verify PIN
                        </button>

                        <div className="text-end mt-2">
                          <button
                            type="button"
                            className="btn btn-link text-primary p-0"
                            onClick={handleForgotPin}
                          >
                            Forgot PIN?
                          </button>
                        </div>
                      </form>

                      {/* <div className="text-center mt-3">
                        <button
                          className="btn btn-link"
                          onClick={() => {
                            setShowPinScreen(false);
                          }}
                        >
                          Login with OTP instead
                        </button>
                      </div> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="text-center fixed-bottom">
            <p style={{ fontSize: "12px" }}>
              Assist Buddi Books © {new Date().getFullYear()} Foxaisr Technology
              Pvt. Ltd.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
